 import { Component, Inject, OnInit } from '@angular/core';
import html2canvas from 'html2canvas';
(window as any).html2canvas = html2canvas;

import * as jsPDF from 'jspdf';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

export interface DialogData {
  estadoCivil: string;
  estadoCivlResponsavel1: string;
  estadoCivlResponsavel2: string;
}

@Component({
  selector: 'app-pdf',
  templateUrl: './pdf.component.html',
  styleUrls: ['./pdf.component.css']
})
export class PdfComponent implements OnInit {
  a: any;
  pageHeight;
  constructor(
    private sanitizer: DomSanitizer,
    private pdf: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  gerarPDF() {

    let specialElementHandlers = {
      '#formulario': function (element, renderer) {
        return true
      },

      '#formResp': function (element, renderer) {
        return true
      },
    };


    let documento = new jsPDF('p', 'mm', 'a4');

    let nomeResp1 = (<HTMLInputElement>document.getElementById("nomeResponsavel1")).value;

    let grauParentescoResp1 = (<HTMLInputElement>document.getElementById("grauParentescoResp1")).value;

    let rgResponsavel1 = (<HTMLInputElement>document.getElementById("rgResponsavel1")).value;

    let cpfResponsavel1 = (<HTMLInputElement>document.getElementById("cpfResponsavel1")).value;

    let nacionalidadeResp1 = (<HTMLInputElement>document.getElementById("nacionalidadeResp1")).value;

    let profissaoResp1 = (<HTMLInputElement>document.getElementById("profissaoResp1")).value;

    let enderecoResponsavel1 = (<HTMLInputElement>document.getElementById("enderecoResponsavel1")).value;
    let numEnderecoResp1 = (<HTMLInputElement>document.getElementById("numEnderecoResponsavel1")).value;

    let bairroResponsavel1 = (<HTMLInputElement>document.getElementById("bairroResponsavel1")).value;

    let cidadeResponsavel1 = (<HTMLInputElement>document.getElementById("cidadeResponsavel1")).value;

    let estadoResponsavel1 = (<HTMLInputElement>document.getElementById("estadoResponsavel1")).value;

    let cepResponsavel1 = (<HTMLInputElement>document.getElementById("cepResponsavel1")).value;

    let telefoneResponsavel1 = (<HTMLInputElement>document.getElementById("telefoneResponsavel1")).value;

    let telefoneCelularResponsavel1 = (<HTMLInputElement>document.getElementById("telefoneCelularResponsavel1")).value;

    let emailResponsavel1 = (<HTMLInputElement>document.getElementById("emailResponsavel1")).value;

    let dataNascimentoResponsavel1 = (<HTMLInputElement>document.getElementById("dataNascimentoResponsavel1")).value;


    // //Resp2
    let nomeResp2 = (<HTMLInputElement>document.getElementById("nomeResponsavel2")).value;

    let grauParentescoResp2 = (<HTMLInputElement>document.getElementById("grauParentescoResp2")).value;

    let rgResponsavel2 = (<HTMLInputElement>document.getElementById("rgResponsavel2")).value;

    let cpfResponsavel2 = (<HTMLInputElement>document.getElementById("cpfResponsavel2")).value;

    let nacionalidadeResp2 = (<HTMLInputElement>document.getElementById("nacionalidadeResp2")).value;

    let profissaoResp2 = (<HTMLInputElement>document.getElementById("profissaoResp2")).value;

    let enderecoResponsavel2 = (<HTMLInputElement>document.getElementById("enderecoResponsavel2")).value;
    let numEnderecoResp2 = (<HTMLInputElement>document.getElementById("numEnderecoResponsavel2")).value;

    let bairroResponsavel2 = (<HTMLInputElement>document.getElementById("bairroResponsavel2")).value;

    let cidadeResponsavel2 = (<HTMLInputElement>document.getElementById("cidadeResponsavel2")).value;

    let estadoResponsavel2 = (<HTMLInputElement>document.getElementById("estadoResponsavel2")).value;

    let cepResponsavel2 = (<HTMLInputElement>document.getElementById("cepResponsavel2")).value;

    let telefoneResponsavel2 = (<HTMLInputElement>document.getElementById("telefoneResponsavel2")).value;

    let telefoneCelularResponsavel2 = (<HTMLInputElement>document.getElementById("telefoneCelularResponsavel2")).value;

    let emailResponsavel2 = (<HTMLInputElement>document.getElementById("emailResponsavel2")).value;

    let dataNascimentoResponsavel2 = (<HTMLInputElement>document.getElementById("dataNascimentoResponsavel2")).value;

    documento.addPage();
    documento.addPage();
    documento.addPage();
    documento.addPage();
    documento.addPage();
    documento.addPage();
    documento.addPage();
    documento.addPage();
    documento.addPage();
    documento.addPage();
    documento.addPage();
    documento.addPage();
    documento.addPage();
    documento.addPage();

    documento.setPage(1);
    documento.setFontStyle("bold");
    documento.setFontSize(12)


    documento.setFontStyle("bold");
    var pageHeight = documento.internal.pageSize.height || documento.internal.pageSize.getHeight();
    var pageWidth = documento.internal.pageSize.width || documento.internal.pageSize.getWidth();


    let str = "CONTRATO DE PRESTAÇÃO DE SERVIÇOS EM PROCESSAMENTO, CRIOGENIA E ";
    documento.text(str, pageWidth / 2, pageHeight  - 286, 'center');
    let str2 = "ARMAZENAMENTO DE MATERIAL BIOLÓGICO ";
    documento.text(str2, pageWidth / 2, pageHeight  - 278, 'center');

    documento.setFontStyle("normal");
    documento.setFontSize(10)

    documento.setFontStyle("normal");
    documento.text("N° do CONTRATO                                                 Para uso CPC", 10, 35);

    documento.text("São Partes no presente Instrumento:", 10, 45);

    var pagina1I = "I) de um lado, CURITIBA BIOTECNOLOGIA LTDA., sociedade por quotas de responsabilidade limitada, nome fantasia CURITYBA BIOTECH, com sede na Rua Prof. Pedro Viriato Parigot de Souza, 5300, Bloco Marrom, 1° andar, sala 111, Campo Comprido, CEP: 81.280-330, Curitiba-PR, Brasil, inscrita no CNPJ/MF sob o n° 10.313.059/0001-93, e, inscrita no CRO-PR sob no 3360 e CRM-PR sob n° 10133, por seu representante legal, doravante denominada CONTRATADA; e";
    documento.text(pagina1I, 10, 51, { align: "justify", lineHeightFactor: 1.5, maxWidth: 190 });
    documento.text("II) de outro lado:", 10, 73);



    var pagina1Resp1 = "Nome do CONTRATANTE 1: " + nomeResp1 + ", Grau de parentesco: " + grauParentescoResp1 +", RG n°:" + rgResponsavel1 + ", CPF/MF n°: " + cpfResponsavel1
    + "RG n°: " + rgResponsavel1 + ", Estado Civil: " + this.data.estadoCivlResponsavel1 + ", Nacionalidade: " + nacionalidadeResp1 + ", Profissão: " + profissaoResp1
    + ", Endereço: " + enderecoResponsavel1 + ", n°: " + numEnderecoResp1 + ", Bairro: " +  bairroResponsavel1 + ", Município: " + cidadeResponsavel1 + ", Estado: "
    + estadoResponsavel1 + ", CEP: " + cepResponsavel1 + ", Tel. Res.: " + telefoneResponsavel1 + ", Tel. Celular: " + telefoneCelularResponsavel1 + ", Email: "
    + emailResponsavel1 + ", Data de nascimento: " + dataNascimentoResponsavel1;

    documento.text(pagina1Resp1, 10, 80, { align: "justify", lineHeightFactor: 1.5, maxWidth: 190 });

    documento.text("e", 10, 115);

    var pagina1Resp2 = "Nome do CONTRATANTE 2: " + nomeResp2 + ", Grau de parentesco: " + grauParentescoResp2 +", RG n°:" + rgResponsavel2 + ", CPF/MF n°: " + cpfResponsavel2
    + "RG n°: " + rgResponsavel2 + ", Estado Civil: " + this.data.estadoCivlResponsavel2 + ", Nacionalidade: " + nacionalidadeResp2 + ", Profissão: " + profissaoResp2
    + ", Endereço: " + enderecoResponsavel2 + ", n°: " + numEnderecoResp2 + ", Bairro: " +  bairroResponsavel2 + ", Município: " + cidadeResponsavel2 + ", Estado: "
    + estadoResponsavel2 + ", CEP: " + cepResponsavel2 + ", Tel. Res.: " + telefoneResponsavel2 + ", Tel. Celular: " + telefoneCelularResponsavel2 + ", Email: "
    + emailResponsavel2 + ", Data de nascimento: " + dataNascimentoResponsavel2;

    documento.text(pagina1Resp2, 10, 125, { align: "justify", lineHeightFactor: 1.5, maxWidth: 190 });

    documento.setFontStyle("normal");
    documento.text("1", 110, 290);

    //Paciente

    documento.setFontStyle("normal");
    documento.setFontSize(10);
    documento.setPage(2);

    let nome = (<HTMLInputElement>document.getElementById("nome")).value;

    let rg = (<HTMLInputElement>document.getElementById("rg")).value;

    let cpf = (<HTMLInputElement>document.getElementById("cpf")).value;

    let nacionalidade = (<HTMLInputElement>document.getElementById("nacionalidade")).value;

    let profissao = (<HTMLInputElement>document.getElementById("profissao")).value;

    let endereco = (<HTMLInputElement>document.getElementById("endereco")).value;
    let numEndereco = (<HTMLInputElement>document.getElementById("numEndereco")).value;

    let bairro = (<HTMLInputElement>document.getElementById("bairro")).value;

    let cidade = (<HTMLInputElement>document.getElementById("cidade")).value;

    let estado = (<HTMLInputElement>document.getElementById("estado")).value;

    let cep = (<HTMLInputElement>document.getElementById("cep")).value;

    let telefone = (<HTMLInputElement>document.getElementById("telefone")).value;

    let telefoneCelular = (<HTMLInputElement>document.getElementById("telefoneCelular")).value;

    let dataNascimento = (<HTMLInputElement>document.getElementById("dataNascimento")).value;

    let email = (<HTMLInputElement>document.getElementById("email")).value;

    let telefoneComercial = (<HTMLInputElement>document.getElementById("telefoneComercial")).value;

    var pagina2Paciente = "Nome do BENEFICIÁRIO (Paciente): " + nome + ", RG nº: " + rg + ", CPF/MF nº: " + cpf + ", Estado Civil: " + this.data.estadoCivil
    + ", Nacionalidade: " + nacionalidade + ", Profissão: " + profissao + ", Endereço: " + endereco + ", n° " + numEndereco +  ", Bairro: " + bairro + ", Município: " + cidade
    + ", Estado: " + estado + ", CEP: " + cep + ", Tel. Res.: " + telefone + ", Tel. Celular: " + telefoneCelular + ", E-mail: " + email + ", Tel. Com.: "
    + telefoneComercial + ", Data de nascimento: " + dataNascimento + ", "
    documento.text(pagina2Paciente, 10, 23, { align: "justify", lineHeightFactor: 1.5, maxWidth: 186 });

    documento.text("Profissional responsável pela coleta: _____________________________________", 10, 66);
    documento.text("Inscrição no Conselho: _____________________________________", 10, 72);
    documento.text("Estado: _____________________________________", 10, 78);
    documento.text("Telefone (  ) _____________________________________", 10, 84);

    var pagina2Texto = "Quando o BENEFICIÁRIO for maior de 18 anos, deve-se repetir no campo BENEFICIÁRIO os dados inseridos no campo CONTRATANTE 1"
    documento.text(pagina2Texto, 10, 93, { align: "justify", lineHeightFactor: 1.5, maxWidth: 186 });

    documento.text("Responsável pelo preenchimento: ________________________________________________", 10, 111);

    var pagina2Texto2 = "doravante denominados conjuntamente como CONTRATANTES, ambos, integrando o presente na qualidade de representantes legais (quando o "
    + "beneficiário for menor ou incapaz), o qual doravante será denominado simplesmente como BENEFICIÁRIO";
    documento.text(pagina2Texto2, 10, 123, { align: "justify", lineHeightFactor: 1.5, maxWidth: 186 });


    var pagina2Texto3 = "têm entre si pactuado, na melhor forma de direito, o presente Contrato, que se constitui nos termos e cláusulas a seguir:";
    documento.text(pagina2Texto3, 10, 145, { align: "justify", lineHeightFactor: 1.5, maxWidth: 186 });

    var pagina2Texto4 = "CONSIDERANDO que a criopreservação é um método que pode armazenar células por período indeterminado, sendo desconhecido o prazo de validade "
    + "das células criopreservadas, o que impossibilita a garantia sobre a sua durabilidade;"
    documento.text(pagina2Texto4, 10, 163, { align: "justify", lineHeightFactor: 1.5, maxWidth: 186 });

    var pagina2Texto5 = "CONSIDERANDO que a CONTRATADA é uma ENTIDADE HABILITADA a isolar, manipular e armazenar material biológico sob regime de "
    + "criopreservação ou não, como CENTRO DE PROCESSAMENTO CELULAR (CPC), e está obrigada a observar as regras impostas pela legislação vigente;"
    documento.text(pagina2Texto5, 10, 181, { align: "justify", lineHeightFactor: 1.5, maxWidth: 186 });

    var pagina2Texto6 = "CONSIDERANDO, por derradeiro, que os CONTRATANTES declaram, sob as penas da lei, que são responsáveis legais do BENEFICIÁRIO."
    documento.text(pagina2Texto6, 10, 205, { align: "justify", lineHeightFactor: 1.5, maxWidth: 186 });

    documento.text("Resolvem as Partes:", 10, 223);

    documento.setFontStyle("bold");
    documento.text("CLÁUSULA PRIMEIRA - DAS DEFINIÇÕES", 10, 235);
    documento.text("Para fins de interpretação do presente Contrato, as expressões a seguir terão os seguintes significados:", 10, 241);

    documento.setFontStyle("normal");
    documento.text("(a) “armazenamento” significa a guarda de material biológico extraído de tecidos humanos;", 10, 247);

    var pagina2Texto7 = "(b) “banco autólogo” significa banco de armazenamento de células destinadas à utilização do próprio indivíduo de quem as células foram extraídas;"
    documento.text(pagina2Texto7, 10, 253, { align: "justify", lineHeightFactor: 1.5, maxWidth: 186 });

    var pagina2Texto8 = "(c) “células aderidas” são células que se fixam naturalmente nas garrafas de cultivo sob condições de cultivo padrão;";
    documento.text(pagina2Texto8, 10, 263.5, { align: "justify", lineHeightFactor: 1.5, maxWidth: 185 });


    documento.text("2", 110, 290);

    //Pagina 3
    documento.setFontSize(10);
    documento.setPage(3);

    var pagina3Texto1 = "(d) “células de interesse terapêutico” refere-se a células que a literatura científica demonstra possibilidade de uso com finalidade terapêutica;"
    documento.text(pagina3Texto1, 10, 23, { align: "justify", lineHeightFactor: 1.5, maxWidth: 186 });

    var pagina3Texto2 = "(e) “células-tronco mesenquimais” (cuja sigla usual vem do termo em inglês, mesenchymal stem cells - MSCs)  significa células primitivas, "
    +"encontradas nos tecidos adultos, capazes de se multiplicar gerando novas células idênticas e, potencialmente capazes de se diferenciar em células e tecidos especializados;"
    documento.text(pagina3Texto2, 10, 33, { align: "justify", lineHeightFactor: 1.5, maxWidth: 186 });

    documento.text("(f) “CPC” nomenclatura usada pela legislação vigente, que significa, CENTRO DE PROCESSAMENTO CELULAR;", 10, 49);

    var pagina3Texto3 = "(g) “criopreservação” refere-se a submeter o material biológico ao congelamento sob taxa regulada de resfriamento em equipamento adequado;"
    documento.text(pagina3Texto3, 10, 55, { align: "justify", lineHeightFactor: 1.5, maxWidth: 186 });

    var pagina3Texto4 = "(h) “entidade habilitada” significa toda empresa, pública ou privada, notoriamente reconhecida no campo da ciência e da pesquisa, como tendo capacitação técnica na área de manipulação e criopreservação de material "
    + "biológico e habilitação segundo as normas de biossegurança e das boas práticas de laboratório e da legislação vigente;"
    documento.text(pagina3Texto4, 10, 65.5, { align: "justify", lineHeightFactor: 1.5, maxWidth: 186 });

    var pagina3Texto5 = "(i) “material biológico” qualquer tecido humano proveniente de intervenção clínica, com possibilidade de obtenção de células com finalidade de uso em pesquisa ou terapêutica;"
    documento.text(pagina3Texto5, 10, 81, { align: "justify", lineHeightFactor: 1.5, maxWidth: 186 });

    var pagina3Texto6 = "(j) “quantidade de material coletado e armazenado” refere-se ao volume de material biológico coletado e ao número de células disponíveis para armazenamento, respectivamente. A quantidade de material "
    + "armazenado é, em geral, o parâmetro utilizado por pesquisadores (equipe técnica) para avaliar a qualidade do material e caberá à equipe técnica avaliar a viabilidade quando de uma possível utilização; ";
    documento.text(pagina3Texto6, 10, 91, { align: "justify", lineHeightFactor: 1.5, maxWidth: 186 });

    var pagina3Texto7 = "(k) “TCLE” refere-se ao Termo de Consentimento Livre e Esclarecido que deve ser preenchido no momento de cada coleta;"
    documento.text(pagina3Texto7, 10, 112, { align: "justify", lineHeightFactor: 1.5, maxWidth: 186 });

    documento.text("(l) “viabilidade celular” refere-se à porcentagem de células vivas dentro de uma população de células.", 10, 122.5);


    documento.setFontStyle("bold");
    documento.text("CLÁUSULA SEGUNDA - DO OBJETO", 10, 137);
    documento.setFontStyle("normal");

    documento.text("Constitui  objeto deste Contrato a prestação de serviço de transporte, processamento, criopreservação, com ou sem", 10, 143);
    documento.text("armazenamento de material biológico com o intuito de preservação de células e seus subprodutos; ", 10, 149);
    documento.setFontStyle("bold");
    documento.text("Parágrafo Primeiro", 10, 155);
    documento.setFontStyle("normal");
    documento.text("– A CONTRATADA  somente  receberá  material  biológico oriundo de profissional previamente ", 45, 155);
    documento.text("habilitado  e  credenciado  pelo  CPC,  ficando  isenta  de  quaisquer  responsabilidades  pela  não recepção ou pelo", 10, 161);
    documento.text("descarte de qualquer material biológico proveniente de terceiros que não atendam rigorosamente tais condições.", 10, 167);
    documento.setFontStyle("bold");
    documento.text("Parágrafo Segundo", 10, 173);
    documento.setFontStyle("normal");
    documento.text("– O  presente   contrato  se  destina  à  prestação  de  serviço  de  transporte,  processamento, ", 46, 173);
    documento.text("criopreservação   com  ou  sem  armazenamento  de  material  biológico  oriundo  de  local  anatômico  devidamente", 10, 179);
    documento.text("especificado  na  Ficha  de  Triagem  Clínica,  documento  anexo  a  este  instrumento  e  atestado  pelo  profissional", 10, 185);
    documento.text("CREDENCIADO.  O  armazenamento  de  um  ou  mais grupos celulares  distintos,  coletados  no  mesmo momento ", 10, 191);
    documento.text("cirúrgico   ou   não   e  nova  prestação  de  serviço  de  transporte,  processamento,  criopreservação  com  ou  sem ", 10, 197);
    documento.text("armazenamento,  serão  objeto  de TERMO ADITIVO a este contrato, onde as Partes ajustarão os valores das taxas", 10, 203);
    documento.text("que  incidirão  sobre  o  serviço  de  processamento  de  material biológico, com ou sem armazenamento de grupo(s)", 10, 209);
    documento.text("celular(es) adicional(is), mantendo-se, porém, todos os termos, cláusulas e condições gerais deste instrumento.", 10, 215);
    documento.setFontStyle("bold");
    documento.text("Parágrafo Terceiro", 10, 221);
    documento.setFontStyle("normal");
    documento.text("– Em  caso  de  novas  coletas  de material biológico com o intuito de obtenção de células para ", 45, 221);
    documento.text("armazenamento também deverá ser realizada uma nova triagem clínica e laboratorial. ", 10, 227);
    documento.text("3.1.1 – Realizar o processamento, a criopreservação com ou sem armazenamento de material biológico, coletado do", 10, 233);
    documento.setFontStyle("bold");
    documento.text("CLÁUSULA TERCEIRA - DAS OBRIGAÇÕES DAS PARTES", 10, 245);
    documento.setFontStyle("normal");
    documento.text("3.1 - Cabe à CONTRATADA:", 10, 251);


    documento.text("3", 110, 290);

    //Página 4
    documento.setFontSize(10);
    documento.setPage(4);



    documento.text("3.1.1 – Realizar o processamento, a criopreservação com ou sem armazenamento de material biológico, coletado do", 12, 23);
    documento.text("BENEFICIÁRIO  durante  procedimento  cirúrgico,  desde  que  tal coleta e o acondicionamento do material biológico ", 12, 29);
    documento.text("tenha  sido  efetuado  por  profissional capacitado e habilitado pela CONTRATADA, cujo credenciamento esteja ativo", 12, 35);
    documento.text("(válido)  e  que  possua  instrução  para  utilizar o material específico de coleta e para seguir as informações técnicas", 12, 41);
    documento.text("fornecidas  pela  CONTRATADA. Caso  o material biológico tenha sido coletado e acondicionado por profissional não", 12, 47);
    documento.text("capacitado,  habilitado  e  credenciado junto  à CONTRATADA, ela ficará isenta de quaisquer responsabilidades pela", 12, 53);
    documento.text("não   recepção   ou   pelo   descarte   de  qualquer   material  biológico  proveniente  de  terceiros  que  não  atendam ", 12, 59);
    documento.text("rigorosamente essas condições;", 12, 65);
    documento.text("3.1.2 - Responsabilizar-se  pela  gestão  do  transporte  do  material biológico coletado pelo profissional credenciado", 12, 71);
    documento.text("pelo CPC até suas instalações;", 12, 77);
    documento.text("3.1.3 - Quando  da  contratação para armazenamento de células, verificar se a quantidade de células obtidas após o", 12, 83);
    documento.text("processamento  apresenta  o  número  de células suficiente para garantir que sejam armazenadas no mínimo 1 (um)", 12, 89);
    documento.text("milhão de células aderidas;", 12, 95);
    documento.text("3.1.4 - Promover  testes  no  material  biológico  e  informar,  por  escrito,  aos  CONTRATANTES,  e  ao profissional ", 12, 101);
    documento.text("CREDENCIADO, quando houver risco de impossibilidade de uso das células processadas;", 12, 107);
    documento.text("3.1.5 - Realizar  todos  os  procedimentos  por  meio  de  técnicos  treinados  e  em  instalações  adequadas  para  o", 12, 113);
    documento.text("processamento do material biológico, seguindo as recomendações da legislação vigente;", 12, 119);
    documento.text("3.1.6 - Armazenar  as  células  em  local  fixo  e  determinado, que permita sua localização com rapidez, facilidade e ", 12, 125);
    documento.text("segurança, de acordo com as normas vigentes;", 12, 131);
    documento.text("3.1.7 - Garantir  que  as  células  armazenadas  não  sejam  utilizadas  para quaisquer finalidades de pesquisa ou de", 12, 137);
    documento.text("ensaios  laboratoriais  sem  o  consentimento  dos  CONTRATANTES,  enquanto  vigente  este  Contrato. Os  testes ", 12, 143);
    documento.text("mencionados  no  item  3.1.4  não  se  enquadram  na regra proibitiva desta cláusula e os dados obtidos poderão ser", 12, 149);
    documento.text("utilizados,  também,  para  a  melhoria  do controle de qualidade do CPC e para o desenvolvimento científico na área;", 12, 155);
    documento.text("3.1.8 - Garantir  que  as  células  armazenadas,  em  caso  de  transferência  para  outro depositário, por  sua própria", 12, 161);
    documento.text("iniciativa, sejam encaminhadas à uma ENTIDADE HABILITADA;", 12, 167);
    documento.text("3.1.9 - Disponibilizar  as  células  armazenadas,  de acordo com a legislação vigente. Quando liberadas, deverão ser", 12, 173);
    documento.text("acompanhadas  de  laudo técnico, em  caso de transferência para outro depositário, nos termos da Cláusula Décima ", 12, 179);
    documento.text("Terceira. A  partir  do recebimento das células pela nova ENTIDADE HABILITADA indicada pelos CONTRATANTES,", 12, 185);
    documento.text("a CONTRATADA  ficará  eximida  de  quaisquer responsabilidades decorrentes da manipulação, armazenamento ou", 12, 191);
    documento.text("utilização    das   células,  bem   como  da  finalidade  que  lhe  será  atribuída.  Entretanto,  fica  a  nova  ENTIDADE", 12, 197);
    documento.text("HABILITADA,  obrigada  a  informar  ao  CPC CURITYBA BIOTECH, os dados exigidos conforme legislação vigente;", 12, 203);
    documento.text("3.1.10 - Enviar  aos  profissionais  CREDENCIADOS,  em  um  dos  endereços  cadastrados  para  a realização  dos", 12, 209);
    documento.text("procedimentos   de   coleta, todo  o  material  necessário  e  adequado  para  a  realização  do  acondicionamento  e", 12, 215);
    documento.text("transporte     do   material   biológico   coletado,   doravante   denominado   como  “kit   para   transporte”,  ficando  a", 12, 221);
    documento.text("CONTRATADA  isenta  de  quaisquer  responsabilidades, caso os CONTRATANTES não realizem a consulta inicial ", 12, 227);
    documento.text("e  o  agendamento  prévio  da  coleta  com  o  profissional CREDENCIADO e, sobretudo, caso os CONTRATANTES", 12, 233);
    documento.text("não  comuniquem  à  CONTRATADA  sobre  a  data  agendada  para  a  coleta  e não certifiquem com o profissional ", 12, 239);
    documento.text("a  disponibilidade  do  material  necessário  para  o acondicionamento  e  transporte, na forma prevista nas cláusulas ", 12, 245);
    documento.text("3.2.1 e 3.2.2.", 12, 251);

    documento.text("3.2 - Cabe aos CONTRATANTES:", 12, 263);
    documento.text("3.2.1 - Agendar  consulta  inicial  com  um  profissional  CREDENCIADO  ao  CPC que determinará  o  momento da", 12, 269);

    documento.text("4", 110, 290);

    //Página 5
    documento.setFontSize(10);
    documento.setPage(5);
    documento.text("coleta  do  material  biológico,  certificando-se  com  o profissional, com a antecedência mínima de 24 (vinte e quatro) ", 10, 23);
    documento.text("horas,  que  o material  necessário para o correto acondicionamento e transporte do material biológico coletado tenha ", 10, 29);
    documento.text("sido  previamente disponibilizado pela CONTRATADA ao profissional, inclusive em relação à quantidade necessária e", 10, 35);
    documento.text("adequada  ao(s)  procedimento(s)  a  ser(em)  realizado(s), sob  pena  de ficar a CONTRATADA eximida de quaisquer", 10, 41);
    documento.text("responsabilidades  pela  não  realização  do  transporte  e  processamento,  bem  como  impossibilitada de cumprir as", 10, 47);
    documento.text("demais cláusulas contratuais por eventual perda do material coletado;", 10, 53);
    documento.text("3.2.2 – Comunicar  a  CONTRATADA sobre a data agendada para a coleta do material (Cláusula 3.2.1) e certificar-se", 10, 59);
    documento.text("de  que  o profissional  CREDENCIADO  comunicou  à  CONTRATADA  sobre  a data agendada, com a antecedência", 10, 65);
    documento.text("mínima       de        24        (vinte e quatro)        horas,        pelos        e-mails         suporte@curitybabiotech.com.br    e", 10, 71);
    documento.text("administrativo@curitybabiotech.com.br,  sob  pena de ficar a CONTRATADA eximida de quaisquer responsabilidades", 10, 77);
    documento.text("pela  não  realização  do  transporte  e  processamento,  bem  como  impossibilitada  de cumprir as demais cláusulas", 10, 83)
    documento.text("contratuais por eventual perda do material coletado;", 10, 89);
    documento.text("3.2.3 - Enviar  à  CONTRATADA, no período de 7 (sete) dias antes ou 7 dias após a coleta, o comprovante (protocolo)", 10, 95);
    documento.text("de  coleta  sanguínea  para   comprovação  da  realização  dos  exames  sorológicos  previstos  em  lei,  sob  pena da", 10, 101)
    documento.text("CONTRATADA  descartar   o  material  recebido  sem  que  haja  qualquer  ônus  à  CONTRATADA e sem que haja a", 10, 107);
    documento.text("devolução dos pagamentos que possam ter sido realizados pelos CONTRATANTES;", 10, 113);
    documento.text("3.2.4 - Enviar    à     CONTRATADA     em    até    7   (sete)    dias   pelo    e-mail   suporte@curitybabiotech.com.br  e ", 10, 119);
    documento.text("administrativo@curitybabiotech.com.br   o   resultado  dos  exames  sorológicos,  caso  não  tenham  sido  realizados ", 12, 125);
    documento.text("previamente  à  coleta, para  que  o  material  processado  possa ser armazenado em conformidade com a legislação", 10, 131);
    documento.text("vigente;", 10, 137);
    documento.text("3.2.5 - Enviar    à     CONTRATADA     em    até    7   (sete)    dias   pelo    e-mail   suporte@curitybabiotech.com.br  e  ", 10, 143);
    documento.text("administrativo@curitybabiotech.com.br    uma    cópia    do    histórico   de    vacinação   (cartão   de   vacinação)   do", 10, 149);
    documento.text("BENEFICIÁRIO;", 10, 155);
    documento.text("3.2.6 - Comunicar,  formalmente  e  por  escrito, à CONTRATADA, qualquer modificação na relação jurídica  existente", 10, 161);
    documento.text("entre   os  dois  CONTRATANTES,  que  possa  afetar  a  representação  legal  do  BENEFICIÁRIO  em  relação  este,", 10, 167);
    documento.text("Contrato,   encaminhando   cópia   do   documento  oficial  que  determinar  tal  modificação,  bem  como  a  indicação", 10, 173);
    documento.text("de  qual  dos CONTRATANTES será o responsável legal pelo presente Contrato junto à CONTRATADA, sob pena de,", 10, 179);
    documento.text("em  assim  não  procedendo,  desobrigar a CONTRATADA de qualquer responsabilidade oriunda de determinação de ", 10, 185);
    documento.text("qualquer dos CONTRATANTES;", 10, 191);
    documento.text("3.2.7 - Pagar,  no  tempo  e  local  devidos,  o  valor  pactuado  entre  as  Partes  para  a  prestação  dos  serviços  ora", 10, 197);
    documento.text("contratados;", 10, 203);
    documento.text("3.2.8 - Comunicar  à  CONTRATADA,  por  escrito, no prazo máximo de 10 (dez) dias, qualquer mudança de endereço", 10, 209);
    documento.text(" e/ou telefone(s);", 10, 215);
    documento.text("3.2.9 - Pagar  as  despesas  com  frete pela remessa (transporte) do material biológico até a matriz da CONTRATADA,", 10, 221);
    documento.text("de  acordo  com a tabela de preços em vigor, nas regiões onde for necessária a cobrança do frete pelo transporte e/ou ", 10, 227);
    documento.text("o  valor  correspondente  ao  deslocamento  de  um  transportador,  mediante pagamento à vista com cartão de débito,", 10, 233);
    documento.text("cartão de crédito ou boleto bancário com vencimento em 20 (vinte) dias após a coleta do material biológico.", 10, 239);

    documento.setFontStyle("bold");
    documento.text("CLÁUSULA QUARTA - DO MATERIAL PARA A COLETA", 10, 261);
    documento.setFontStyle("normal");
    documento.text("A   CONTRATADA   disponibilizará   aos   profissionais   CREDENCIADOS   o   “kit   para   transporte”.   Entretanto,  é ", 10, 267);
    documento.text("imprescindível  que  os  CONTRATANTES  realizem  o agendamento  prévio  para a realização da coleta, bem como", 10, 273);

    documento.text("5", 110, 290);

    //Página 6
    documento.setFontSize(10);
    documento.setPage(6);
    documento.text("comuniquem à CONTRATADA sobre a data agendada, nos termos das cláusulas 3.2.1 e 3.2.2, sob risco de perda do ", 12, 23);
    documento.text("material  biológico  caso  ele  não  seja  acondicionado  adequada  e  imediatamente  após  a  remoção cirúrgica,", 12, 29);
    documento.text("inviabilizando o processamento e guarda das células. ", 12, 35)

    documento.setFontStyle("bold");
    documento.text("Parágrafo Primeiro", 12, 41);
    documento.setFontStyle("normal");
    documento.text("– Na  hipótese  de  não  utilização  do  kit  para  transporte,  este  poderá  ficar  sob  a  guarda do", 45, 41);
    documento.text("profissional  por  até  30  (trinta)  dias.  Caso  nenhuma  amostra  seja  enviada  até  o  final  destes  30  (trinta) dias, o ", 12, 47);
    documento.text("profissional CREDENCIADO deverá seguir as instruções contidas no “Manual técnico do credenciado”, atualizado. ", 12, 53);

    documento.setFontStyle("bold");
    documento.text("CLÁUSULA QUINTA - DOS CRITÉRIOS DE EXCLUSÃO DA AMOSTRA", 12, 65);
    documento.setFontStyle("normal");
    documento.text("Nos  termos  da  legislação  em  vigor,  a CONTRATADA só poderá efetuar o recebimento do material biológico dentro", 12, 71);
    documento.text("das seguintes condições. ", 12, 77);
    documento.text("- Ausência de processos infecciosos conhecidos e/ou aparentes;", 12, 83);
    documento.text("- Remoção cirúrgica realizada por profissional com credenciamento válido pelo CPC;", 12, 89);
    documento.text("- Condições clínicas do paciente que viabilizem a coleta;", 12, 95);
    documento.text("- Situação de transporte que não indique risco na manutenção da biossegurança do processo.", 12, 101);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Primeiro", 12, 107);
    documento.setFontStyle("normal");
    documento.text("– A  CONTRATADA ficará absolutamente isenta de quaisquer responsabilidades caso o material ", 45, 107);
    documento.text("biológico seja coletado fora das condições listadas nesta Cláusula.", 12, 113);

    documento.setFontStyle("bold");
    documento.text("CLÁUSULA SEXTA – DO ARMAZENAMENTO DAS CÉLULAS ", 12, 125);
    documento.setFontStyle("normal");
    documento.text("Na  hipótese  de  serem  coletados  tecidos  de  fontes  distintas  em  um  mesmo  procedimento  cirúrgico,  gerando a ", 12, 131);
    documento.text("possibilidade   de   armazenamento   de   um   segundo,   terceiro,  quarto  ou  quinto  grupos  celulares,  estes  serão", 12, 137);
    documento.text("processados  cabendo   aos  CONTRATANTES,  no  prazo  máximo  de  10 (dez)  dias  após  serem  cientificados da", 12, 143);
    documento.text("viabilidade   das   células   para   armazenamentos  nos  termos  do  parágrafo  quinto  desta  cláusula,  optarem  pela", 12, 149);
    documento.text("manutenção  do  armazenamento  de  apenas  1  (uma)  fonte  ou,  pelo armazenamento de células oriundas de mais ", 12, 155);
    documento.text("de 1 (uma) fonte, devendo pagar os valores detalhados em TERMO ADITIVO a este Contrato.", 12, 161);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Primeiro - A  coleta  do material biológico será realizada de acordo com a indicação clínica do caso,", 12, 167);
    documento.text("dependendo  da  opção dos CONTRATANTES pelo armazenamento de um ou mais grupos celulares de fontes", 12, 173);
    documento.text("distintas.", 12, 179);

    documento.text("Parágrafo Segundo", 12, 185);
    documento.setFontStyle("normal");
    documento.text("– Caso não haja a expressa opção pelos CONTRATANTES sobre o armazenamento do material", 46, 185);
    documento.text("de  fontes  distintas,  no  prazo  definido no caput desta cláusula, a CONTRATADA procederá o encaminhamento  das", 12, 191);
    documento.text("amostras, conforme os dados constantes no TCLE. ", 12, 197);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Terceiro", 12, 203);
    documento.setFontStyle("normal");
    documento.text("– Na  hipótese  das  células  de fontes distintas serem armazenadas separadamente, não haverá ", 45, 203);
    documento.text("acréscimo  no  valor  da  taxa  de  contrato,  entretanto,  os  CONTRATANTES  deverão pagar os valores da anuidade", 12, 209);
    documento.text("adicional  referente  ao  armazenamento  do(s)  grupo(s)  celular(es)  extra(s),  conforme  tabela  de  preços  em  vigor", 12, 215);
    documento.text("(Cláusula Décima Primeira) e constante em TERMO ADITIVO.", 12, 221);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Quarto", 12, 227);
    documento.setFontStyle("normal");
    documento.text("– O  pagamento  da primeira anuidade referente ao armazenamento de grupos celulares definidos", 43, 227);
    documento.text("em  TERMO ADITIVO, deverá ser realizado por meio de transferência bancária, cartão de débito ou cartão de crédito,", 12, 233);
    documento.text("ou  por  meio  de  boleto  bancário  com  vencimento  no  dia  15  (quinze)  do  mês  subsequente  ao  mês em  que os", 12, 239);
    documento.text("CONTRATANTES forem cientificados desta viabilidade. ", 12, 245);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Quinto", 12, 251);
    documento.setFontStyle("normal");
    documento.text("– Considerando  que  a  possibilidade  de  armazenamento  de  grupos  de  células adicionais está", 43, 251);
    documento.text("condicionada  à  multiplicação das células coletadas, a CONTRATADA informará ao(s) CONTRATANTE(S) por escrito", 12, 257);
    documento.text("quanto  à  confirmação  da  viabilidade do armazenamento de uma, duas, três, quatro ou cinco grupos de amostras de", 12, 263);
    documento.text("células.", 12, 269)

    documento.setFontStyle("bold");
    documento.text("Parágrafo Sexto", 12, 275);
    documento.setFontStyle("normal");
    documento.text("– As  demais  anuidades  referentes  ao  armazenamento  de  grupos  de  células  adicionais  serão", 42, 275);

    documento.text("6", 110, 290);

    //Página 7
    documento.setFontSize(10);
    documento.setPage(7);
    documento.text("cobradas  juntamente  com  a anuidade das células da primeira fonte e sofrerão o mesmo reajuste monetário que rege", 12, 23);
    documento.text("este contrato.", 12, 29);

    documento.setFontStyle("bold");
    documento.text("CLÁUSULA SÉTIMA - DO PRAZO DE VIGÊNCIA DO CONTRATO", 12, 41);
    documento.setFontStyle("normal");
    documento.text("Este   Contrato   terá   a   vigência  de  12  (doze)  meses,  contados  a  partir  da  data  da  coleta  das  células  para  o ", 12, 47);
    documento.text("armazenamento,  sendo  automaticamente  prorrogado,  por  períodos  iguais  e  sucessivos,  salvo  se  quaisquer  das", 12, 53);
    documento.text("Partes  não  se  mostrar  interessada  na  sua prorrogação, o que deverá ser manifestado de forma escrita, por meio de", 12, 59);
    documento.text("notificação  encaminhada  à  outra  Parte,  impreterivelmente  até  o  início  dos  últimos  30  (trinta) dias de vigência do", 12, 65);
    documento.text("contrato.", 12, 71);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Primeiro", 12, 77);
    documento.setFontStyle("normal");
    //deixar esse captu itálico!
    documento.text("– Uma  vez   prorrogada   a  vigência   do   contrato,   nos  termos  do   caput  desta  cláusula,  os ", 45, 77);
    documento.text("CONTRATANTES  se  obrigam  ao  pagamento  integral dos valores, taxas e anuidades previstas neste instrumento e", 12, 83);
    documento.text("em TERMO(S) ADITIVO(S).", 12, 89);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Segundo", 12, 95);
    documento.setFontStyle("normal");
    documento.text("– Em  caso  de  não  renovação do presente Contrato, a CONTRATADA deverá dar a destinação ", 45, 95);
    documento.text("permitida  na legislação  vigente, expressa no TCLE, ficando isenta de quaisquer responsabilidades sobre o que vier a", 12, 101);
    documento.text("ocorrer com o material biológico.", 12, 107);

    documento.setFontStyle("bold");
    documento.text("CLÁUSULA OITAVA - DA CONFIDENCIALIDADE", 12, 119);
    documento.setFontStyle("normal");
    documento.text("Tendo em vista a natureza do objeto deste Contrato e as condições impostas pela ética profissional, a CONTRATADA", 12, 125);
    documento.text("se  obriga  a  manter, sob total sigilo, as informações cadastrais fornecidas pelos CONTRATANTES para identificação", 12, 131);
    documento.text("da pessoa do BENEFICIÁRIO, sejam a respeito daqueles ou sejam relacionadas ao BENEFICIÁRIO.", 12, 137);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Primeiro", 12, 143);
    documento.setFontStyle("normal");
    documento.text("– A   CONTRATADA   se   responsabilizará  pelos  atos  de  seus  prepostos,  representantes  ou ", 45, 143);
    documento.text("empregados,  no  que  diz  respeito  ao  cumprimento  das obrigações de confidencialidade e segurança mencionadas", 12, 149);
    documento.text("acima.", 12, 155);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Segundo", 12, 161);
    documento.setFontStyle("normal");
    documento.text("– Esta  cláusula  tornar-se-á  sem  efeito caso os CONTRATANTES autorizem à CONTRATADA ", 46, 161);
    documento.text("formalmente o uso de imagens e/ou depoimentos para fins de divulgação científica ou comercial.", 12, 167);

    documento.setFontStyle("bold");
    documento.text("CLÁUSULA NONA - DA RESPONSABILIDADE DA CONTRATADA POR ATOS DE TERCEIROS", 12, 179);
    documento.setFontStyle("normal");
    documento.text("A  CONTRATADA  poderá  contratar  terceiros  para executar serviços a que esteja obrigada por força deste Contrato,", 12, 185);
    documento.text("salvo  determinação  legal  em  contrário, visando o melhor cumprimento do objeto deste instrumento,ficando sob sua", 12, 191);
    documento.text("única e inteira responsabilidade os atos praticados pelo terceiro contratado, seja por eleição, seja por nomeação, seja", 12, 197);
    documento.text("por vigilância.", 12, 203);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Primeiro", 12, 209);
    documento.setFontStyle("normal");
    documento.text("– Se  o  material  biológico  de  que  trata  este  Contrato for enviado (transportado) por terceiros", 45, 209);
    documento.text("estranhos  aos  da  CONTRATADA,  os  CONTRATANTES reconhecem e declaram que sobre a CONTRATADA não ", 12, 215);
    documento.text("recairá  qualquer  responsabilidade  legal,  bem  como  quaisquer obrigações financeiras, se sofrer avarias, impedir a", 12, 221);
    documento.text("rastreabilidade ou se tornar inadequada para o fim de que trata o objeto deste Contrato.", 12, 227);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Segundo", 12, 233);
    documento.setFontStyle("normal");
    documento.text("– Na hipótese de transferência da responsabilidade sobre o objeto deste Contrato por iniciativa", 46, 233);
    documento.text("da CONTRATADA, os CONTRATANTES, quando solicitarem, deverão ser comunicados, formalmente, a respeito.", 12, 239);

    documento.setFontStyle("bold");
    documento.text("CLÁUSULA DÉCIMA -  DA   RESPONSABILIDADE   DA   CONTRATADA   COM   RELAÇÃO   A   RESULTADOS ", 12, 251);
    documento.text("TERAPÊUTICOS EM FACE DAS CÉLULAS ARMAZENADAS", 12, 257);
    documento.text("Os   CONTRATANTES   reconhecem   e   declaram   a   total  isenção   de   obrigação   e  responsabilidade  da", 12, 263);
    documento.text("CONTRATADA,  de  seus  empregados ou colaboradores, diretores ou administradores, sócios ou acionistas, ", 12, 269);
    documento.text("consultores  ou  executivos, bem como de terceiros por ela contratados, na forma do que estabelece o caput", 12, 275);

    documento.setFontStyle("normal");
    documento.text("7", 110, 290);

    //Página 8
    documento.setFontStyle("bold");
    documento.setPage(8);
    documento.text("da  Cláusula Nona, quanto a futuros resultados clínicos ou terapêuticos decorrentes da utilização das células ", 12, 23);
    documento.text("armazenadas, incluindo-se as MSCs, reconhecendo ainda que o escopo deste Contrato não envolve qualquer ", 12, 29);
    documento.text("garantia  quanto:  à  conveniência  e/ou quantidade  do  material coletado e armazenado para o tratamento de", 12, 35);
    documento.text("quaisquer  patologias;  ao  sucesso  de tratamento de doenças, traumas ou lesões, via transplante de células", 12, 41);
    documento.text("do  BENEFICIÁRIO;  às  vantagens  do  transplante  das células armazenadas do BENEFICIÁRIO sobre outros", 12, 47);
    documento.text("tipos de tratamento que utilizem células multiplicadas e/ou armazenadas.", 12, 53);

    documento.text("CLÁUSULA   DÉCIMA   PRIMEIRA -  DO   VALOR  DO  SERVIÇO  CONTRATADO;  DO  SEU  REAJUSTE  E  DO ", 12, 65);
    documento.text("PAGAMENTO", 12, 71)
    documento.setFontStyle("normal");
    documento.text("Para  a  consecução  do  serviço  ora  contratado,  os  CONTRATANTES concordam em pagar, à CONTRATADA, os ", 12, 77);
    documento.text("valores  relativos  à  (i)  a taxa de contrato, (ii) a taxa de transporte e/ou deslocamento do transportador, quando for o", 12, 83);
    documento.text("caso  e,  anualmente,  (iii)  a  taxa  referente  ao  armazenamento,  previstas  na  tabela de preços em vigor no ato da", 12, 89);
    documento.text("assinatura deste Contrato e descritas a seguir:", 12, 95);
    documento.text("Para  fins  deste  Contrato  a  (i)  taxa  de  contrato  se refere à remuneração pelo isolamento celular, processamento", 12, 101);
    documento.text("pelas  verificações  e  testes  realizados no material biológico, entre outras atividades realizadas pela CONTRATADA,", 12, 107);
    documento.text("bem  como  pelos  custos,  despesas  e  encargos tributários ou administrativos incidentes sobre ou necessários para", 12, 113);
    documento.text("suas  atividades,  serviços  ou  materiais;  (ii)  taxa  de  transporte  e/ou  deslocamento  se refere à remuneração pela", 12, 119);
    documento.text("de  material  biológico  do  local da coleta pelo profissional CREDENCIADO até a sede da CONTRATADA; e (iii) taxa", 12, 125);
    documento.text("de  armazenamento  se  refere  à  remuneração  pelo  armazenamento  do  material  biológico  processado, conforme", 12, 131);
    documento.text("declarado no final deste Contrato.", 12, 137);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Primeiro", 12, 143);
    documento.setFontStyle("normal");
    documento.text("– Os   CONTRATANTES   pagarão  à  CONTRATADA,  à  vista  e  no  ato  da  assinatura  deste ", 45, 143);
    documento.text("instrumento, o valor relativo à taxa de contrato. Os pagamentos poderão ser feitos por meio de transferência bancária,", 12, 149);
    documento.text("cartão  de  débito,  cartão  de  crédito  ou  boleto bancário. O A taxa de transporte, que varia de acordo com o local de", 12, 155);
    documento.text("coleta,   e   o   pagamento  das  anuidades  especificadas  em  TERMO  ADITIVO,  poderão  ser  pagas  por  meio  de", 12, 161);
    documento.text("transferência  bancária,  cartão  de  débito  ou cartão de crédito, ou boleto bancário com vencimento no dia 15 do mês", 12, 167);
    documento.text("subsequente  à  ciência  da  viabilidade do armazenamento da(s) amostra(s) coletada(s). As anuidades seguintes das", 12, 173);
    documento.text("amostras  armazenadas  vencerão  sempre  no  dia  30  (trinta)  do  mês  subsequente  ao  mês  da coleta do material", 12, 179);
    documento.text("biológico do BENEFICIÁRIO.", 12, 185);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Segundo", 12, 191);
    documento.setFontStyle("normal");
    documento.text("– Os  valores  das  taxas  dos serviços contratados serão reajustados anualmente, com base no", 46, 191);
    documento.text("índice  acumulado  nos  últimos  12  (doze)  meses  anteriores  à  data  base  (Cláusula Sétima). Caso a legislação de ", 12, 197);
    documento.text("regência   em   vigor   permita   o  reajuste  em  menor  período, os  valores  das  taxas  serão  reajustados  na  menor", 12, 203);
    documento.text("periodicidade  permitida,  sem  que,  para tanto, haja necessidade de qualquer aditamento do presente instrumento. O ", 12, 209);
    documento.text("índice  de  reajuste  eleito  pelas  Partes  e  o  IGP-M/FGV  ou,  na  falta  dele,  sucessivamente  os  seguintes  índices  ", 12, 215);
    documento.text("IPC-M/FGV,  IGP-DI/FGV,   IGP- 10/FGV,   INCC/FGV,  INPC/IBGE,  IPCA/IBGE  e IPC-SP/FIPE. Na falta de todos os ", 12, 221);
    documento.text("mencionados índices, aplicar-se-á outro índice que venha a substituí-los legalmente ou, em não havendo substituição", 12, 227);
    documento.text("legal, o substituição legal, o índice que melhor reflita a reposição da inflação acumulada no período.", 12, 233);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Terceiro", 12, 239);
    documento.setFontStyle("normal");
    documento.text("– O reajuste  incidirá  automaticamente  sobre os valores das taxas, independentemente do envio", 44, 239);
    documento.text("de  notificação  ou  da  prática  de  qualquer  ato  de  comunicação pela CONTRATADA, tão logo transcorrida a menor", 12, 245);
    documento.text("prioridade  permitida  em  lei, obrigando-se os CONTRATANTES ao pagamento integral dos valores reajustados, sem ", 12, 251);
    documento.text("qualquer direito  de  escusa  da  obrigação  de que trata esta cláusula, sob o argumento de ausência de notificação ou ", 12, 257);
    documento.text("de ato de comunicação.", 12, 263);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Quarto", 12, 269);
    documento.setFontStyle("normal");
    documento.text("– O   pagamento   dos   valores   devidos   deverá   ser   efetuado   diretamente   no   escritório  da ", 43, 269);
    documento.text("CONTRATADA,  ou em outro local por ela autorizado, por cartão de débito, de crédito, ou por meio de boleto bancário.", 12, 275);
    documento.text("Contudo,  se  por   algum   motivo   não   chegar   às   mãos  dos  CONTRATANTES  a  cobrança  da  anuidade, nada,", 12, 281);

    documento.text("8", 110, 290);

    //Página 9
    documento.setPage(9);
    documento.text("absolutamente  nada,  justificará  a  ausência  do  pagamento  devido.  Caso  os  CONTRATANTES  não  recebam a", 12, 23);
    documento.text("da  anuidade,  o  pagamento poderá  ser feito diretamente nas instalações da CONTRATADA, que se compromete a", 12, 29);
    documento.text("comunicar formalmente aos CONTRATANTES qualquer alteração de seu endereço num prazo máximo de 30 (trinta)", 12, 35);
    documento.text("dias, no  endereço corrente dos CONTRATANTES que tiver sido por último informado, por escrito, à CONTRATADA.", 12, 41);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Quinto", 12, 47);
    documento.setFontStyle("normal");
    documento.text("– Em  caso  de  desistência  da  prestação  dos serviços objeto deste Contrato antes da coleta do", 42, 47);
    documento.text("material biológico, o valor eventualmente pago pelos CONTRATANTES no ato da assinatura deste instrumento será", 12, 53);
    documento.text("restituído sem qualquer atualização monetária e acréscimo de juros, deduzindo-se da quantia a ser restituída o valor", 12, 59);
    documento.text("correspondente  à  taxa  de  administração,  no  valor  de  15%, que os CONTRATANTES reconhecem devido como", 12, 65);
    documento.text("contraprestação  dos  serviços  até então prestados e custos, despesas e encargos suportados pela CONTRATADA.", 12, 71);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Sexto", 12, 77);
    documento.setFontStyle("normal");
    documento.text("– Em caso de desistência da prestação dos serviços objeto deste Contrato, antes da realização do", 40, 77);
    documento.text("primeiro   armazenamento,   o  valor  eventualmente   pago   pelos   CONTRATANTES  no  ato  da  assinatura deste ", 12, 83);
    documento.text("instrumento será restituído sem qualquer atualização monetária e acréscimo de juros, deduzindo-se da quantia a ser", 12, 89);
    documento.text("restituída  o  valor  correspondente  à 50%  dos  valores pagos, que os CONTRATANTES reconhecem devido como ", 12, 95);
    documento.text("contraprestação  dos  serviços  até então prestados e custos, despesas e encargos suportados pela CONTRATADA,", 12, 101);
    documento.text("exceto a taxa de transporte cujo valor não será restituído.", 12, 107);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Sétimo", 12, 113);
    documento.setFontStyle("normal");
    documento.text("– Na  hipótese em  que for verificada a inviabilidade de isolamento de MSCs ou outras células de", 42, 113);
    documento.text("interesse  terapêutico,  oriundas  do  material  biológico  recebido, por qualquer razão técnica, ou na hipótese de não", 12, 119);
    documento.text("realização  da  coleta  por  conta  da  ocorrência de um dos critérios de exclusão previstos na Cláusula Quinta desse", 12, 125);
    documento.text("Contrato,   ou   caso  o  profissional  responsável  pelo  procedimento  cirúrgico  não  seja  credenciado  ao  CPC  da ", 12, 131);
    documento.text("CONTRATADA,  o  valor eventualmente pago pelos CONTRATANTES, no ato da assinatura deste instrumento, será ", 12, 137);
    documento.text("restituído  sem  qualquer  atualização  monetária  e  acréscimo  de  juros, limitando-se ao correspondente a 50% dos", 12, 143);
    documento.text("valores   pagos,  que  os  CONTRATANTES  reconhecem  devidos  como  contraprestação  dos  serviços  até  então", 12, 149);
    documento.text("prestados  e  custos,  despesas  e  encargos  suportados pela CONTRATADA, exceto a taxa de transporte cujo valor ", 12, 155);
    documento.text("não será restituído.", 12, 161);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Oitavo", 12, 167);
    documento.setFontStyle("normal");
    documento.text("– Este Contrato foi firmado considerando a atual conjuntura econômica, inclusive internacional, os", 41, 167);
    documento.text("tributos,  as  contribuições  e  os  encargos  atualmente  vigentes,  ficando  desde  já  ajustado  entre as Partes que o ", 12, 173);
    documento.text("equilíbrio econômico-financeiro  deste  ajuste,  que  é  necessário  ao  seu  integral cumprimento, somente  pode ser ", 12, 179);
    documento.text("atingido   se   mantidas  as  circunstâncias  correntes.  Desta  forma,  qualquer  alteração  na  conjuntura  econômica,  ", 12, 185);
    documento.text("relacionadas   ao   aumento,  mas  à  elas  não  se limitando, de tributos, de contribuições ou de encargos sociais ou ", 12, 191);
    documento.text("alteração  substancial  de  preços  praticados  por  fornecedoresda  CONTRATADA  que  repercutem  em  percentual ", 12, 197);
    documento.text("superior   a   5%  (cinco  por  cento)  dos  dos  valores  vigentes  cobrados,  serão  comunicadas  imediatamente  aos  ", 12, 203);
    documento.text("CONTRATANTES com a explicitação econômica dos seus impactos, para fins de reajuste dos valores pactuados, ", 12, 209);
    documento.text("com  o  escopo  de ser mantida a mesma equação  econômico-financeira do ato da assinatura deste instrumento. A  ", 12, 215);
    documento.text("partir  do  recebimento  desta  comunicação, os CONTRATANTES poderão optar pela rescisão do Contrato, no prazo", 12, 221);
    documento.text("de  30  (trinta)  dias.  No  silêncio  dos  CONTRATANTES,  será  presumida aconcordância tácita com o aumento dos ", 12, 227);
    documento.text("valores.", 12, 233)

    documento.setFontStyle("bold");
    documento.text("Parágrafo Nono", 12, 239);
    documento.setFontStyle("normal");
    documento.text("– O  pagamento  dos  honorários  profissionais  devidos   em  razão  da  consulta, do exame clínico,", 40, 239);
    documento.text("da  preparação  do sítio cirúrgico, da realização da coleta, acondicionamento, preenchimento dos documentos, envio", 12, 245);
    documento.text("para   o   transporte,  além  do  “kit  para  transporte”,  deve  ser  realizado  pelos  CONTRATANTES  diretamente  ao", 12, 251);
    documento.text("profissional  CREDENCIADO.  Os  valores  descritos  neste  parágrafo  são devidos em razão dos serviços prestados", 12, 257);
    documento.text("pelo  profissional  CREDENCIADO  aos  CONTRATANTES,  não  se  incluindo  e  não  podendo  ser  deduzidos,  em ", 12, 263);
    documento.text("hipótese  alguma,  dos  valores  devidos  à  CONTRATADA como contraprestação dos serviços que são objeto deste ", 12, 269);
    documento.text("contrato (Cláusula Primeira, caput).", 12, 275);

    documento.text("9", 110, 290);

    //Página 10
    documento.setPage(10);
    documento.setFontStyle("bold");
    documento.text("CLÁUSULA DÉCIMA SEGUNDA - DA MULTA ", 12, 23);
    documento.setFontStyle("normal");
    documento.text("O  descumprimento  das obrigações pecuniárias contraídas por força deste Contrato, sujeitará os CONTRATANTES,", 12, 29);
    documento.text("o   pagamento   de   multa  moratória  de  2%  (dois  por  cento)  incidentes   sobre  o  valor  total  devido,  atualizado ", 12, 35);
    documento.text("monetariamente  de acordo com o Parágrafo Segundo da Cláusula Décima Primeira e acrescido de juros moratórios", 12, 41);
    documento.text("de juros moratórios de 1% (um por cento) ao mês.", 12, 47);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Primeiro", 12, 53);
    documento.setFontStyle("normal");
    documento.text("– Havendo   inadimplência   superior   a   30  (trinta)   dias,   os   CONTRATANTES,   além  das", 45, 53);
    documento.text("consequências previstas no caput desta cláusula,serão obrigados a pagar o valor total devido que será acrescido de", 12, 59);
    documento.text("honorários  advocatícios, custas e quaisquer outras despesas judiciais e extrajudiciais, na hipótese de a cobrança se", 12, 65);
    documento.text("dar por meio judicial ou em razão de inscrição em cadastros de inadimplentes ou de protesto de título.", 12, 71);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Segundo", 12, 77);
    documento.setFontStyle("normal");
    documento.text("– Caso  a  CONTRATADA,  por  falha  exclusivamente  sua  e  que  não  se constitua em caso ", 46, 77);
    documento.text("fortuito  ou  força  maior,  venha  causar  a  inutilização  das  células armazenadas, ficará obrigada ao pagamento de", 12, 83);
    documento.text("multa  compensatória  correspondente  ao  dobro  do valor pago pelos CONTRATANTES no ato da assinatura deste", 12, 89);
    documento.text("instrumento. A multa somente  será  aplicável se e quando, cumulativamente: (a) as células inutilizadas se tornarem ", 12, 95);
    documento.text("imprescindíveis  para   determinada  patologia  médica  indispensável  à  integridade do BENEFICIÁRIO; e (b) que a", 12, 101);
    documento.text("tecnologia  da  medicina  à  época  da  necessidade de utilização das células, comprovadamente, for capaz de obter", 12, 107);
    documento.text("determinada solução a partir desta tecnologia.", 12, 113);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Terceiro", 12, 119);
    documento.setFontStyle("normal");
    documento.text("– Na  hipótese  do  parágrafo  anterior,  caso  não  seja comprovado pelos CONTRATANTES a ", 45, 119);
    documento.text("relevância   e   a   possibilidade   de   utilização   das   células   armazenadas,  nos  termos  das  letras  (a)  e  (b),  a", 12, 125);
    documento.text("CONTRATADA restituirá aos CONTRATANTES tão somente os valores eventualmente recebidos desde a coleta do", 12, 131);
    documento.text("material, corrigido monetariamente e acrescido de multa de 2% (dois por cento).", 12, 137);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Quarto", 12, 143);
    documento.setFontStyle("normal");
    documento.text("– Na hipótese de a coleta deixar de ser realizada por efetiva falha da CONTRATADA, o contrato ", 43, 143);
    documento.text("será encerrado  e será restituído aos CONTRATANTES todo o valor eventualmente pago até a data agendada para", 12, 149);
    documento.text("a coleta, que ficarão dispensados de qualquer pagamento futuro.", 12, 155);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Quinto", 12, 161);
    documento.setFontStyle("normal");
    documento.text("– O  pagamento  de que trata os parágrafos segundo e terceiro acima serão efetuados no prazo ", 43, 161);
    documento.text("máximos de 60 (sessenta) dias, após a comprovação da responsabilidade da CONTRATADA.", 12, 167);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Sexto", 12, 173);
    documento.setFontStyle("normal");
    documento.text("– O  pagamento  de  que  trata  o  parágrafo  quarto  acima  será efetuado no prazo máximo de 30", 40, 173);
    documento.text("(trinta) dias, após a comprovação da responsabilidade da CONTRATADA.", 12, 179);

    documento.setFontStyle("bold");
    documento.text("CLÁUSULA DÉCIMA TERCEIRA - DA REQUISIÇÃO DAS CÉLULAS ARMAZENADAS PELOS CONTRATANTES", 12, 191);
    documento.setFontStyle("normal");
    documento.text("Tendo  em  vista  a  natureza  das células  armazenadas,  os CONTRATANTES somente poderão requisitá-las para ", 12, 197);
    documento.text("serem  encaminhadas  para  fins  comprovadamente  de  tratamento médico e/ou odontológico e de prevenção de a", 12, 203);
    documento.text("alguma   patologia  do  BENEFICIÁRIO,  desde  que  tal  utilização  esteja  devidamente  reconhecida  pelos  órgãos", 12, 209);
    documento.text("competentes  ou  por  ordem  judicial. Os CONTRATANTES se obrigam a assumir toda e qualquer responsabilidade,", 12, 215);
    documento.text("bem  como  a  indenizar  integral  e imediatamente  quaisquer danos causados à CONTRATADA, caso destinem  as", 12, 221);
    documento.text("células armazenadas para finalidade ou utilização considerada irregular ou ilícita pelas normas de regência.", 12, 227);


    documento.setFontStyle("bold");
    documento.text("Parágrafo Primeiro", 12, 233);
    documento.setFontStyle("normal");
    documento.text("– Caso  os  CONTRATANTES,  por  meio  do profissional  responsável  pela  aplicação  clínica,", 45, 233);
    documento.text("requisitem  as  células  armazenadas  para  utilização  no  Brasil  ou no exterior, a  CONTRATADA  providenciará  o", 12, 239);
    documento.text("preparo  adequado  das  células  para o transporte. Os custos do preparo, processamento (multiplicação de células)", 12, 245);
    documento.text("e  de  transporte  das  células  armazenadas  até  a  unidade  terapêutica  indicada serão integralmente pagos pelos", 12, 251);
    documento.text("CONTRATANTES.  A  CONTRATADA  se  compromete  a disponibilizar as células seguindo o protocolo terapêutico", 12, 257);

    documento.text("10", 110, 290);

    //Página 11
    documento.setPage(11);
    documento.text("clínico  indicado  pelo  profissional  responsável  pela  aplicação  clínica,  porém,  caso  esta  aplicação  necessite da ", 12, 23);
    documento.text("utilização  de  algum  veículo  e/ou  arcabouço  (suporte) específico, que extrapolem o processo de expansão celular,", 12, 29);
    documento.text("estes   custos   serão   arcados   pelos   CONTRATANTES.  Além  disto,  a  CONTRATADA  não  irá  disponibilizar o", 12, 35);
    documento.text("profissional  para  realizar  qualquer  tipo  de procedimento terapêutico, mesmo quando relacionado a procedimentos", 12, 41);
    documento.text("devidamente autorizados pelos órgãos competentes e realizados dentro do território nacional. ", 12, 47);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Segundo", 12, 53);
    documento.setFontStyle("normal");
    documento.text("– Caso  os  CONTRATANTES façam a requisição das células armazenadas para transferência ", 46, 53);
    documento.text("para outra ENTIDADE HABILITADA estes deverão arcar com os custos de transferência e a CONTRATADA indicará", 12, 59);
    documento.text("os meios seguros para este transporte, desde que de acordo com a legislação vigente.", 12, 65);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Terceiro", 12, 71);
    documento.setFontStyle("normal");
    documento.text("– Além  das  despesas  com  o  transporte,  os  custos  de  transferência  referidos no parágrafo", 45, 71);
    documento.text("anterior equivalem ao valor de 01 (uma) anuidade do contrato (valor em vigor no ano da transferência) ou, caso haja", 12, 77);
    documento.text("crédito de período da anuidade em vigor, o valor da diferença pró-rata", 12, 83);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Quarto", 12, 89);
    documento.setFontStyle("normal");
    documento.text("– A   CONTRATADA   disponibilizará   as  células  armazenadas  em recipiente  próprio,  que  os ", 43, 89);
    documento.text("CONTRATANTES se comprometem a restituí-lo, sob pena de indenizá-la imediatamente pelo seu extravio.", 12, 95);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Quinto", 12, 101);
    documento.setFontStyle("normal");
    documento.text("– Salvo  instrução  em  sentido  diverso  feito  a  qualquer  tempo  pelos  CONTRATANTES,  em ", 43, 101);
    documento.text("conjunto  ou  separadamente,  a  CONTRATADA  está  autorizada  a  atender  a  requisição  de  entrega das células", 12, 107);
    documento.text("armazenadas feita por qualquer um dos CONTRATANTES individualmente.", 12, 113);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Sexto", 12, 119);
    documento.setFontStyle("normal");
    documento.text("– A  CONTRATADA  tem  o  prazo  de  até  3  (três)  dias,  após  o recebimento da solicitação dos", 40, 119);
    documento.text("CONTRATANTES,  através  de  e-mail  ou  carta, para informá-los sobre a documentação necessária para liberação", 12, 125);
    documento.text("das células armazenadas.", 12, 131);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Sétimo", 12, 137);
    documento.setFontStyle("normal");
    documento.text("– Em  situações  onde  a  quantidade  de células armazenadas esteja em quantidade insuficiente", 42, 137);
    documento.text("para uma aplicação terapêutica e/ou a técnica de administração exija um tempo maior de preparo, a CONTRATADA", 12, 143);
    documento.text("compromete-se  em  adequar  o  material.  Entretanto,  como  se  trata  de  material  vivo, não pode se comprometer", 12, 149);
    documento.text("quanto  ao  tempo  necessário  para  que  tal  material esteja pronto e/ou que a quantidade de células solicitada seja", 12, 155);
    documento.text("atingida.", 12, 161);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Oitavo", 12, 167);
    documento.setFontStyle("normal");
    documento.text("– As  células  em cultivo podem sofrer alteração genética durante o processo de expansão celular,", 41, 167);
    documento.text("portanto,  testes  genéticos  para verificar a estabilidade e segurança no uso destas células poderão ser requisitados", 12, 173);
    documento.text("da  aplicação  clínica. Os custos dos testes genéticos e demais testes solicitados pelo profissional, responsável pela", 12, 179);
    documento.text("quando  aplicação  clínica  e/ou  pelas  autoridades  competentes  à época da utilização, serão integralmente pagos ", 12, 185);
    documento.text("pelos CONTRATANTES.", 12, 191);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Nono", 12, 197);
    documento.setFontStyle("normal");
    documento.text("– A  utilização  clínica  das  células  cultivadas  e  com  alterações  genéticas comprovada será de", 40, 197);
    documento.text("responsabilidade  do  profissional que realizou a solicitação do material armazenado, eximindo a CONTRATADA de", 12, 203);
    documento.text("quaisquer danos ou responsabilidades que possam afetar a saúde do BENEFICIÁRIO.", 12, 209);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Décimo", 12, 215);
    documento.setFontStyle("normal");
    documento.text("– Caso os CONTRATANTES façam a requisição para disponibilização das células no curso da", 45, 215);
    documento.text("vigência  deste  contrato,  não  terão  direito  de  restituição  dos  valores das taxas já pagos, nem tampouco ficarão", 12, 221);
    documento.text("isentos de pagar os valores devidos em razão da contratação, além daqueles previstos nesta Cláusula.", 12, 227);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Décimo Primeiro", 12, 233);
    documento.setFontStyle("normal");
    documento.text("– Após o recebimento dessa documentação e liberação do material, a CONTRATADA", 58, 233);
    documento.text("ficará  liberada  de  toda  e qualquer responsabilidade sobre as células encaminhadas, bem como da restituição de", 12, 239);
    documento.text("quaisquer valores ou do pagamento de quaisquer indenizações, seja a que título for.", 12, 245);

    documento.setFontStyle("bold");
    documento.text("CLÁUSULA DÉCIMA QUARTA - DA RESILIÇÃO DO CONTRATO", 12, 257);
    documento.setFontStyle("normal");
    documento.text("O  presente  Contrato  poderá  ser  extinto  de comum acordo ou por vontade de uma das Partes. Nesta hipótese a", 12, 263);
    documento.text("resilição unilateral somente será possível se (a) a parte interessada notificar à outra sobre sua intenção, por escrito", 12, 269);
    documento.text("e  com  antecedência  mínima  de  120  (cento  e  vinte)  dias; (b) se tiverem sido honrados todos os compromissos", 12, 275);

    documento.text("11", 110, 290);

    //Página 12
    documento.setPage(12);
    documento.text("assumidos,  inclusive  perante  terceiros,  em   data   anterior  à  manifestação  sobre  a  resilição,  e (c)  se restrita a ", 12, 23);
    documento.text("motivação  da  vontade  às  seguintes  hipóteses:  (c.1)  quando,  por  decisão judicial ou por outra qualquer decisão,", 12, 29);
    documento.text("implicar  a  modificação  do  caráter da representação legal do BENEFICIÁRIO; (c.2) quando a parte CONTRATADA ", 12, 35);
    documento.text("fica  sujeita  à execução judicial sobre seus  bens imóveis; (c.3) quando for declarada falência da CONTRATADA ou ", 12, 41);
    documento.text("insolvência  civil  dos  CONTRATANTES, desde que não fraudulenta; e (c.4) quando os CONTRATANTES não mais", 12, 47);
    documento.text("se  interessarem  pela  manutenção  do  armazenamento das células pertencentes ao BENEFICIÁRIO, e desde que", 12, 53);
    documento.text("este ainda esteja na condição de representado ou assistido pelos CONTRATANTES", 12, 59);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Primeiro", 12, 65);
    documento.setFontStyle("normal");
    documento.text("– Resilido  o  contrato, a CONTRATADA disponibilizará  para  os CONTRATANTES as células ", 45, 65);
    documento.text("armazenadas,  que  deverão  solicitar  a  sua  transferência no prazo máximo de 30 (trinta) dias, ficando, no entanto, ", 12, 71);
    documento.text("obrigados  a  nomear  qualquer  entidade  que  se  enquadre na definição de ENTIDADE HABILITADA constante da ", 12, 77);
    documento.text("Cláusula  Primeira  deste Contrato para que as células sejam encaminhadas, em face da natureza e das normas de", 12, 83);
    documento.text("biossegurança  e  das  boas  práticas  de laboratório para manipulação de material biológico. Os CONTRATANTES", 12, 89);
    documento.text("deverão  arcar  com  os  custos da referida transferência conforme Parágrafo Terceiro da Cláusula Décima Terceira. ", 12, 95);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Segundo", 12, 101);
    documento.setFontStyle("normal");
    documento.text("– Na  hipótese  de  os  CONTRATANTES  não  retirarem  as  células  armazenadas  no prazo ", 46, 101);
    documento.text("estabelecido  no  §  1º,  ou  na  hipótese  dos  os  CONTRATANTES  dispensarem  o  direito  de retirada que lhes é ", 12, 107);
    documento.text("garantido,  a  CONTRATADA  deverá  dar  às  células armazenadas a destinação permitida na legislação vigente, e", 12, 113);
    documento.text("expressa  no  TCLE,  sem  que  os  contratantes  tenham  direito  a  reclamar  quaisquer indenizações, materiais ou", 12, 119);
    documento.text("imateriais.", 12, 125);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Terceiro", 12, 131);
    documento.setFontStyle("normal");
    documento.text("– Alcançando  o  BENEFICIÁRIO  a  maioridade  civil,  este  também  passará  a  figurar como", 45, 131);
    documento.text("contratante   do   presente  Contrato,   e  assumirá  as  obrigações  constantes  neste  Contrato  tal  qual  os  atuais", 12, 137);
    documento.text("CONTRATANTES.", 12, 143);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Quarto", 12, 149);
    documento.setFontStyle("normal");
    documento.text("– A  resilição do contrato, independentemente do tempo de vigência transcorrido, não conferirá", 43, 149);
    documento.text("aos  CONTRATANTES  o direito de restituição dos valores das taxas já pagos, nem tampouco os eximirá de pagar", 12, 155);
    documento.text("os valores devidos em razão da contratação.", 12, 161);

    documento.setFontStyle("bold");
    documento.text("CLÁUSULA DÉCIMA QUINTA - DA RESCISÃO DO CONTRATO", 12, 173);
    documento.setFontStyle("normal");
    documento.text("O  presente  Contrato  poderá  ser  rescindido,  a  qualquer  tempo, após notificação da outra Parte, nos seguintes", 12, 179);
    documento.text("casos:", 12, 185);
    documento.text("(a) não cumprimento, total ou parcial, de qualquer das cláusulas do presente Contrato;", 12, 191);
    documento.text("(b) não  localização  dos  CONTRATANTES,  por  mais  de 90 (noventa)  dias  corridos,  decorrentes  de  falta  de", 12, 197);
    documento.text("comunicação, por parte dos CONTRATANTES, sobre qualquer mudança de endereço ou telefone.", 12, 203);

    documento.setFontStyle("bold");
    documento.text("Parágrafo Único", 12, 209);
    documento.setFontStyle("normal");
    documento.text("– Se  a  rescisão tiver como causa ato ou fato dos CONTRATANTES, eles não terão o direito de ", 40, 209);
    documento.text("restituição  dos  valores  das  taxas já pagos, nem tampouco ficarão isentos de pagar os valores devidos em razão", 12, 215);
    documento.text("da contratação, além de eventuais outros valores, multas ou indenizações previstas neste contrato", 12, 221);

    documento.setFontStyle("bold");
    documento.text("CLÁUSULA DÉCIMA SEXTA - DAS DISPOSIÇÕES GERAIS", 12, 227);
    documento.setFontStyle("normal");
    documento.text("(a)  Caso  o  material  biológico  coletado  não atenda  aos  critérios  estabelecidos  pelo controle de qualidade da ", 12, 233);
    documento.text("CONTRATADA  ou  pela  legislação  vigente  no  que  se  refere  à  presença  de  microrganismos, o material será ", 12, 239);
    documento.text("descartado  e  a CONTRATADA informará aos CONTRATANTES, conforme estabelecido na cláusula 3.1.6 desse", 12, 245);
    documento.text("Contrato;", 12, 251)
    documento.text("(b) A  CONTRATADA  se  reserva  no direito de não realizar o processamento do material biológico coletado caso ", 12, 257);
    documento.text("haja  dúvida  quanto  à integridade do material ou dúvidas na rastreabilidade que possam dificultar ou prejudicar o", 12, 263);
    documento.text("uso futuro;", 12, 269);

    documento.text("12", 110, 290);

    //Página 13
    documento.setPage(13);
    documento.text("(c) Se  os  CONTRATANTES  decidirem  não  manter  as  células armazenadas, a CONTRATADA dará às células a ", 12, 23);
    documento.text("destinação  permitida  na  legislação  vigente  e  de  acordo  com o TCLE assinado sem que os contratantes tenham", 12, 29);
    documento.text("restituição dos valores das taxas já pagos;", 12, 35);
    documento.text("(d) A  tolerância  a  qualquer  violação  do  presente  Contrato  não implicará tolerância a qualquer outra violação ou", 12, 41);
    documento.text("subsequente,  nem  será  interpretada  como  novação  objetiva  ou  alteração  deste  instrumento, mas mero ato de", 12, 47);
    documento.text("liberalidade;", 12, 53)
    documento.text("(e) As  notificações  previstas  neste  Contrato,  bem  como  quaisquer  outras,  deverão ser feitas por escrito e, caso ", 12, 59);
    documento.text("sejam enviadas por Correios,serão encaminhadas à outra parte por carta registrada para o seu endereço, como indi-", 12, 65);
    documento.text("cado anteriormente, e serão consideradas como recebidas na data de retorno do Aviso de Recebimento (AR); se em", 12, 71);
    documento.text("mãos,  as cartas serão consideradas recebidas quando entregues mediante assinatura de protocolo de recebimento;", 12, 77);
    documento.text("(f) A  CONTRATADA  poderá  armazenar  sua  via  deste  Contrato, digitalizado  ou  em outra forma permitida em lei ", 12, 83);
    documento.text("que ateste sua autenticidade; ", 12, 89);
    documento.text("(g) Em  caso  de divergência ou impasse entre os CONTRATANTES em relação a quaisquer das decisões relativas", 12, 95);
    documento.text("a este Contrato, tais como transferência das células, prorrogação do contrato, etc, a CONTRATADA deverá atender ", 12, 101);
    documento.text("às determinações daquele que comprove ter a posse e guarda do BENEFICIÁRIO. Se houver guarda compartilhada, ", 12, 107);
    documento.text("caberá  à  CONTRATADA  observar  o  que  foi  determinado  por  decisão  judicial  ou,  em caso de inexistência de", 12, 113);
    documento.text("determinação  judicial,  incumbirá a ela, CONTRATADA, zelar pela manutenção da situação até então vigente sobre", 12, 119);
    documento.text("a responsabilidade legal e financeira de ambos dos CONTRATANTES solidariamente;", 12, 125);
    documento.text("(h) Os CONTRATANTES  obrigam-se  sob sua única e exclusiva responsabilidade a dar ciência ao BENEFICIÁRIO ", 12, 131);
    documento.text("dos  termos  e  condições  deste  Contrato  para  os  devidos  e legais efeitos e do Termo de Consentimento Livre e ", 12, 137);
    documento.text("Esclarecido para atendimento da legislação vigente", 12, 143);

    documento.setFontStyle("bold");
    documento.text("CLAUSULA DÉCIMA SÉTIMA - DO FORO", 12, 155);
    documento.setFontStyle("normal");
    documento.text("Fica  eleito o foro  central da Comarca de Curitiba, Paraná, para dirimir quaisquer questões porventura decorrentes", 12, 161);
    documento.text("do  presente  Contrato,  renunciando  as  Partes,  desde  já, a qualquer outro foro, por mais privilegiado que seja. E,", 12, 167);
    documento.text("por  estarem  as  Partes  justas  e  contratadas,  os  CONTRATANTES e CONTRATADA assinam este Instrumento,", 12, 173);
    documento.text("em 02 (duas) vias de igual teor e forma.", 12, 179);


    documento.setFontStyle("bold");
    documento.text("PARA PREENCHIMENTO DOS CONTRATANTES:", 12, 191);
    documento.setFontStyle("normal");
    documento.text("Declaramos que:", 12, 197);
    documento.text("Os valores ora pactuados neste Contrato são:", 12, 203);
    documento.text("(i) Taxa de Contrato: R$                    (                                                                         )", 12, 209);
    documento.text("(ii) Taxa de Transporte: R$                    (                                                                         ) ", 12, 215);
    documento.text("(de acordo com o local de coleta)", 12, 221);

    documento.text("O  presente  Contrato  obrigará  e  vigorará  em  benefício das Partes ora contratantes, seus sucessores e cessará", 12, 233);
    documento.text("quando do óbito do BENEFICIÁRIO", 12, 239);

    documento.text("13", 110, 290);

    //Página 14
    documento.setPage(14);
    documento.text("CURITIBA ", 12, 23);
    documento.text("__________________________________    __________________________________ ", 40, 51);
    documento.text(" ASSINATURA DO CREDENCIADO 1            ASSINATURA DO CONTRATANTE 2", 43, 57);

    documento.text("__________________________________    __________________________________ ", 40, 75);
    documento.text(" ASSINATURA DO CREDENCIADO               CURITIBA BIOTECNOLOGIA LTDA", 43, 81);

    documento.text("                                  TESTEMUNHAS", 60, 99);

    documento.text("1- NOME: ________________________________________  ASSINATURA: ____________________________", 12, 117);
    documento.text("CPF: _______________________________________  RG: __________________________________________", 12, 123);
    documento.text("ENDEREÇO: _______________________________________________________________________________", 12, 129);
    documento.text("CEP: _______________________", 12, 135);


    documento.text("2- NOME: ________________________________________  ASSINATURA: ____________________________", 12, 147);
    documento.text("CPF: _______________________________________  RG: __________________________________________", 12, 153);
    documento.text("ENDEREÇO: _______________________________________________________________________________", 12, 159);
    documento.text("CEP: _______________________", 12, 165);


    documento.text("14", 110, 290);
    this.removerUltimaPagina(documento);

    this.a = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(documento.output("blob")));

  };


  removerUltimaPagina(documento) {
    var pageCount = documento.internal.getNumberOfPages();
    documento.deletePage(pageCount);
  }


  ngOnInit(): void {
    this.gerarPDF();
  }

}
